import { render, staticRenderFns } from "./finances.vue?vue&type=template&id=abbb9626"
import script from "./finances.vue?vue&type=script&lang=js"
export * from "./finances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports